export class SuperhogSearchResult {
    superhogSearchProperties: SuperhogSearchProperties[];

    constructor(props: { [key in keyof SuperhogSearchResult]?: SuperhogSearchResult[key] }) {
        Object.assign(this, props);
    }
}

export class SuperhogSearchProperties {
    name: string;
    description: string;
    address: string;
    hostName: string;
    hostImage: string;
    stars:string;
    numberOfGuests: number;
    bedrooms: number;
    bathrooms: number;
    imageUrl: string;
    isNewListing: boolean;
    isSuperHost:boolean;
    cacheId: number;
    accommodationId: number;
    city: string;
    createdDate: Date;
    geoLocation: GeoLocation;
}

export class GeoLocation {
    lat: number;
    lng: number;
}